export enum LinkType {
  'Automatic' = 'Automatic',
  'ManyToMany' = 'ManyToMany',
  'ManyToOne' = 'ManyToOne',
  'OneToMany' = 'OneToMany',
  'OneToOne' = 'OneToOne',
}
